import { render, staticRenderFns } from "./TypeSelectScreen.vue?vue&type=template&id=1cb66c32&scoped=true&"
import script from "./TypeSelectScreen.vue?vue&type=script&lang=js&"
export * from "./TypeSelectScreen.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelectScreen.vue?vue&type=style&index=0&id=1cb66c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb66c32",
  null
  
)

export default component.exports